var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#587E85",
    fillRule: "nonzero",
    stroke: "#F9FCEE",
    strokeWidth: 2.224
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.533 14c0-3.602-2.93-6.533-6.533-6.533-3.602 0-6.533 2.93-6.533 6.533 0 3.602 2.93 6.533 6.533 6.533 3.602 0 6.533-2.93 6.533-6.533m1.634 0c0 4.51-3.657 8.167-8.167 8.167S5.833 18.51 5.833 14 9.49 5.833 14 5.833 22.167 9.49 22.167 14m-3.267.817c0 .45-.366.816-.817.816h-3.266c-.903 0-1.634-.73-1.634-1.633V9.917c0-.451.366-.817.817-.817.45 0 .817.366.817.817v3.266c0 .45.367.817.816.817h2.45c.451 0 .817.366.817.817"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPending);
export default __webpack_public_path__ + "static/media/star-pending.f2496abaa30bf01c631cb35e4f1fcebe.svg";
export { ForwardRef as ReactComponent };